// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0fc6de0","content":"_a1d8bf9","list":"_e72b52b"};